import { useQuery } from 'react-query';

import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { DealExcludedLender } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useExcludedLendersQuery(guid: string | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.ExcludedLenders(guid),
		() => AxiosUtils.getResponseData<DealExcludedLender[]>(api.get(CerebroApiEndpoints.ExcludedLenders.Root(guid))),
		{
			enabled: guid !== undefined,
		}
	);
}
